@use 'themes/westfield' as *;
// Textfield styles
// ================

@use 'tools/dirg' as *;
@use 'tools/color' as *;
@use 'tools/typography.module' as *;
@use './field.module' as *;

.Textfield {
  @extend .fieldWrapper;
  @extend .bodyFont;

  .characterCountWrapper {
    position: relative;
    width: 100%;

    .characterCount {
      position: absolute;
      top: -1 * units(1.25);
      right: units(0.5);
      color: color('Grey Dark');

      @include font-size(0);

      &.error {
        color: color('Error');
      }
    }
  }

  .searchIcon {
    width: units(1.25);
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: units(0.5);
    color: color('Grey Dark');

    &.smallSearch {
      width: units(1);
    }
  }
}

.TextfieldHorizontal {
  @extend .fieldHorizontal;
  align-items: baseline;
}

.field {
  @extend .field;
  width: 100%;

  &[type='date'] {
    padding: units(0.5) units(1);
  }

  &[type='search'] {
    padding: units(0.5) units(1) units(0.5) units(2.25);
  }
}

.fieldSmall {
  @extend .fieldSmall;
  width: 100%;

  &[type='date'] {
    padding: units(0.5) units(1);
  }

  &[type='search'] {
    padding: units(0.5) units(1) units(0.5) units(2);
  }
}

.fieldIconContainer {
  @extend .fieldIconContainer;
  width: 100%;
  position: relative;
}

.fieldInvalid {
  @extend .fieldInvalid;
}

.fieldValid {
  @extend .fieldValid;
}

.errorLabel {
  color: color('Error');
}

.passwordPreview {
  position: absolute;
  top: -1 * units(2);
  right: units(1);
  width: units(1.5);
  height: units(1.5);
  background: color('surfaceTertiary');
}

.errorBackground {
  background: color('Error Light');
}

.showHideIcon {
  width: 100%;
  height: 100%;
  fill: color('Grey Dark');
}
